
import React, {useState} from 'react';
import ListTable from '../../../../common/ListTable';
import CustomFilter from '../../../Common/CustomFilter';

const UserListTable = (props) => {
    const {total, loading, defaultCurrent, pageSize,current, onChange} = props
    const [showFilter, setShowFilter] = useState(false);

    const handleFilter = () => {
        setShowFilter((prev) => !prev)
    }

    return (
      <>
        {props.filter && (
          <CustomFilter
            showFilter={showFilter}
            handleFilter={handleFilter}
            tableData={props.dataSource}
            fetchTableData={null}
            filterName="buying_office"
          />
        )}
        <div className="table" style={{ marginTop: 10 }}>
          <ListTable
            loading={loading}
            emptyText="No records to show yet."
            pagination={{
              showSizeChanger: false,
              defaultPageSize: pageSize,
              current: current,
              onChange: onChange,
              defaultCurrent: defaultCurrent,
              total: total,
            }}
            scroll={{ x: true }}
            columns={props.tableColumns}
            dataSource={props.dataSource}
          />
        </div>
      </>
    );
};
export default UserListTable;
